import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  SHORT_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";
import { Dossier } from "../../types/Dossier";

export const getDossier = (dossierId: string, options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["dossier", dossierId],
    queryFn: (): Promise<Dossier> => {
      return fetchWithAuth<Dossier>("getDossier", dossierId);
    },
    refetchOnMount: options.useCached ? true : "always",
    staleTime: SHORT_STALE_TIME,
    enabled: isQueryEnabled(options),
  });
};
